import { z } from 'zod';
import { PlayerSchema } from '../../models/player';
import { DEV_PREFIX, defineEndpoint } from '../endpoint';

/** Seeded characters offered by the local (development) sign-in. */
export const listLocalPlayers = defineEndpoint({
  method: 'GET',
  path: `${DEV_PREFIX}/players`,
  access: 'dev',
  response: z.object({ players: z.array(PlayerSchema) }),
});
